import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import tipCheckoutPromoBackgroundImage from '../../../assets/images/tip-checkout-promo-background.png';
import { zIndexMap } from '../../../shared/config';
import { rubikTypographyStyles } from '../../../shared/ui';

const PromoCard = styled.article.attrs({
  'data-ui': 'tips-checkout-promo-card',
})`
  position: relative;
  min-height: ${({ theme }) => theme.scale.px(106)};
  border-radius: ${({ theme }) => theme.scale.px(11)};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.base};
`;

const PromoBackground = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
})`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const PromoCopy = styled.div`
  position: relative;
  z-index: ${zIndexMap.tipsCheckout.promoForeground};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(5)};
  padding-top: ${({ theme }) => theme.scale.px(30)};
  padding-left: ${({ theme }) => theme.scale.px(13)};
  max-width: ${({ theme }) => theme.scale.px(200)};
`;

const PromoTitle = styled.p`
  ${rubikTypographyStyles};
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(16)};
  font-weight: 600;
  line-height: 1.18;
`;

const PromoSubtitle = styled.p`
  ${rubikTypographyStyles};
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 400;
  line-height: 1.18;
`;

export function TipCheckoutPromoCard() {
  const { t } = useTranslation();

  return (
    <PromoCard>
      <PromoBackground src={tipCheckoutPromoBackgroundImage} />

      <PromoCopy>
        <PromoTitle>{t('tipsCheckout.promoTitle')}</PromoTitle>
        <PromoSubtitle>{t('tipsCheckout.promoSubtitle')}</PromoSubtitle>
      </PromoCopy>
    </PromoCard>
  );
}
